import { createStore } from 'vuex';

import coachesModule from './coaches/index';
import requestsModule from './requests/index'

const store = createStore({
  modules: {
    coaches: coachesModule,
    requests: requestsModule
  },
  // uporabimo userId, da vemo da je ta registrirani uporabnik nato uporabnik na strani
  // njemu se bo nato prikazaloa isLoggedIn stran in tudi preverimo če ta userId že obstaja.
  state() {
    return {
      userId: 'c3',
    };
  },
  getters: {
    // da lahko uporabimo userId ki ga nosi userId getter v actions.js pretko context.rootGetters.userId
    userId(state) {
      return state.userId;
    },
  },
  mutations: {},
  actions: {},
});
export default store;
